import script from "./FlaggedItems.vue?vue&type=script&setup=true&lang=js"
export * from "./FlaggedItems.vue?vue&type=script&setup=true&lang=js"

import "./FlaggedItems.vue?vue&type=style&index=0&id=1694632c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1694632c"]])

export default __exports__